import { defineStore } from "pinia";
import classificationService from "../services/ClassificationService.js";
import viewConfigService from "../services/ViewConfigService.js";

let _loadPromise = null;

export const useFilingPlanStore = defineStore("filingPlan", {
  state: () => ({
    currentPlanName: null,
    planClassement: [],
    natures: [],
    fields: [],
    dictionaries: [],
    lexicons: [],
    viewCategories: [],
    dynamicViews: [],
    loading: false,
    loaded: false,
  }),
  getters: {
    enabledNatures: (state) => state.natures.filter((n) => !n.hide),
    hasPlan: (state) => state.currentPlanName !== null && state.loaded,
  },
  actions: {
    async loadPlan(planName, force = false) {
      if (!planName) {
        return;
      }
      if (this.currentPlanName === planName && this.loaded && !force) {
        return;
      }

      if (_loadPromise && this.currentPlanName === planName) {
        return _loadPromise;
      }

      this.loading = true;
      this.currentPlanName = planName;

      _loadPromise = this._doLoad(planName);
      try {
        await _loadPromise;
      } finally {
        _loadPromise = null;
      }
    },

    async _doLoad(planName) {
      try {
        const plan = await classificationService.getPlan(planName);
        this.planClassement = plan.EMPLACEMENT || plan.PLAN_CLASSEMENT || [];
        this.natures = plan.NATURES || plan.NATURE_DOCUMENT || [];
        this.fields = plan.FIELDS || [];
        this.dictionaries = plan.DICTIONARIES || [];
        this.lexicons = plan.LEXICONS || [];
        this.viewCategories = plan.VIEW_CATEGORIES || [];

        await this._loadDynamicViews();

        this.loaded = true;
      } catch (error) {
        console.error(`Failed to load plan ${planName}:`, error);
        this.reset();
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async _loadDynamicViews() {
      const filenameSet = new Set();
      for (const cat of this.viewCategories) {
        for (const f of cat.views || []) {
          filenameSet.add(f);
        }
      }
      const views = [];
      for (const filename of filenameSet) {
        try {
          const view = await viewConfigService.getView(filename);
          views.push({ ...view, filename });
        } catch {
          // Skip invalid view files
        }
      }
      this.dynamicViews = views;
    },

    reset() {
      this.currentPlanName = null;
      this.planClassement = [];
      this.natures = [];
      this.fields = [];
      this.dictionaries = [];
      this.lexicons = [];
      this.viewCategories = [];
      this.dynamicViews = [];
      this.loaded = false;
      this.loading = false;
    },
  },
});
